"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _Context = _interopRequireDefault(require("./Context"));

var _getTabIndex = _interopRequireDefault(require("./getTabIndex"));

var _inputtableKey = _interopRequireDefault(require("./inputtableKey"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var DEFAULT_STYLE = {
  outline: 0
};

var FocusBox = function FocusBox(_ref) {
  var children = _ref.children,
      disabled = _ref.disabled,
      sendFocusRefProp = _ref.sendFocusRef,
      otherProps = _objectWithoutProperties(_ref, ["children", "disabled", "sendFocusRef"]);

  var sendFocusRefPersist = (0, _react.useRef)(null);
  var patchedSendFocusRef = (0, _react.useMemo)(function () {
    return sendFocusRefProp || sendFocusRefPersist;
  }, [sendFocusRefPersist, sendFocusRefProp]);
  var context = (0, _react.useMemo)(function () {
    return {
      sendFocusRef: patchedSendFocusRef
    };
  }, [patchedSendFocusRef]);
  var focus = (0, _react.useCallback)(function () {
    var current = patchedSendFocusRef.current;
    current && current.focus();
  }, [patchedSendFocusRef]);
  var handleKeyDownCapture = (0, _react.useCallback)(function (event) {
    var altKey = event.altKey,
        ctrlKey = event.ctrlKey,
        key = event.key,
        metaKey = event.metaKey,
        target = event.target;
    var tabIndex = (0, _getTabIndex.default)(target);

    if (altKey || ctrlKey && key !== 'v' || metaKey || !(0, _inputtableKey.default)(key) && key !== 'Backspace') {
      // Ignore if one of the utility key (except SHIFT) is pressed
      // E.g. CTRL-C on a link in one of the message should not jump to chat box
      // E.g. "A" or "Backspace" should jump to chat box
      return;
    }

    if (typeof tabIndex !== 'number' || tabIndex < 0) {
      event.stopPropagation();
      focus();
    }
  }, [focus]);
  return _react.default.createElement(_Context.default.Provider, {
    value: context
  }, _react.default.createElement("div", _extends({}, otherProps, {
    onKeyDownCapture: !disabled && handleKeyDownCapture,
    style: DEFAULT_STYLE,
    tabIndex: -1
  }), typeof children === 'function' ? children({
    focus: focus
  }) : children));
};

FocusBox.defaultProps = {
  children: undefined,
  disabled: false
};
FocusBox.propTypes = {
  children: _propTypes.default.any,
  disabled: _propTypes.default.bool,
  sendFocusRef: _propTypes.default.shape({
    current: _propTypes.default.shape({
      focus: _propTypes.default.func
    })
  }).isRequired
};
var _default = FocusBox;
exports.default = _default;